export const TABLET_SCREEM_WIDTH = 768

export function isMobileView() {
    return window && window.innerWidth <= TABLET_SCREEM_WIDTH 
}